import * as React from 'react';

import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

import { SlatePlugin } from '../../slatePlugins/slatePlugins.types';
import { GapFillBlank } from '../blank-plugin/components/GapFillBlank';
import {
  EXERCISE_GAP_FILL,
  EXERCISE_GAP_FILL_HINTS,
  EXERCISE_GAP_FILL_QUESTION,
  EXERCISE_GAP_FILL_QUESTION_CONTENT,
  PARAGRAPH_TOGGLE,
  BLANK_V2,
  EXPLANATIONS,
  EditorExerciseGapFillOptions, EXPLANATION,
} from './types';
import { GapFillExplanations } from './components/GapFillExplanations';
import { GapFillExplanation } from './components/GapFillExplanation';

const GapFillElement = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() => import('./components/GapFillElement').then((mod) => mod.GapFillElement))
);

const GapFillQuestions = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() => import('./components/GapFillQuestions').then((mod) => mod.GapFillQuestions),
    {
      dependsOn: GapFillElement,
    }
  )
);

const GapFillQuestionContent = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() => import('./components/GapFillQuestionContent').then((mod) => mod.GapFillQuestionContent),
    {
      dependsOn: GapFillElement,
    }
  )
);

const GapFillHints = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() => import('./components/GapFillHints').then((mod) => mod.GapFillHints))
);

const GapFillParagraphToggle = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() => import('./components/GapFillParagraphToggle').then((mod) => mod.GapFillParagraphToggle))
);

const renderElementEditorExerciseGapFill = (options: EditorExerciseGapFillOptions) => (props) => {
    const { element } = props;

    switch (element.type) {
      case PARAGRAPH_TOGGLE: {
        return (element.parentNodeType === EXERCISE_GAP_FILL || element.parentNodeType === EXPLANATIONS) ? (
          <GapFillParagraphToggle {...props} {...options} />
        ) : undefined;
      }

      case EXERCISE_GAP_FILL:
        return <GapFillElement {...props} {...options}/>;

      case EXERCISE_GAP_FILL_QUESTION:
        return <GapFillQuestions {...props} {...options} />;

      case EXERCISE_GAP_FILL_QUESTION_CONTENT:
        return <GapFillQuestionContent {...props} {...options} />;

      case EXPLANATIONS:
        return <GapFillExplanations {...props} {...options} />;

      case EXPLANATION:
        return <GapFillExplanation {...props} {...options} />;

      case EXERCISE_GAP_FILL_HINTS:
        return <GapFillHints {...props} {...options} />;

      case BLANK_V2: {
        return element.parentNodeType === EXERCISE_GAP_FILL_QUESTION_CONTENT ? (
          <GapFillBlank {...props} {...options} />
        ) : undefined;
      }
      default:
        return null;
    }
  }
;

export const EditorExerciseGapFillPlugin = (
  options?: EditorExerciseGapFillOptions,
): SlatePlugin => {
  return {
    renderElement: renderElementEditorExerciseGapFill(options),
  };
};
